import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SnackbarData } from '../../models/snackbar.model';

export const SnackbarActions = createActionGroup({
  source: 'Snackbar',
  events: {
    snackbar_open: props<{ snackbarData: SnackbarData; config?: MatSnackBarConfig }>(),
    snackbar_close: emptyProps()
  }
});
